import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setError(null);
        if (password.length < 8) {
            setError("Le mot de passe doit contenir au moins 8 caractères.");
            return;
        }
        if (password !== confirm) {
            setError("Les mots de passe ne correspondent pas.");
            return;
        }
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            toast.success("Mot de passe modifié. Vous pouvez vous connecter.");
            navigate("/connexion");
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="max-w-md mx-auto px-5 md:px-10 py-16 md:py-24" data-testid="reset-page">
            <p className="bc-label-small">Nouveau mot de passe</p>
            <h1 className="font-serif text-[#D4BC7C] text-4xl sm:text-5xl mt-4">Réinitialisation</h1>
            <div className="bc-hairline-gold my-6" />
            {!token ? (
                <div className="text-[#F2ECE0]/85">
                    Lien invalide.{" "}
                    <Link to="/mot-de-passe-oublie" className="text-[#D4BC7C] underline">
                        Demander un nouveau lien
                    </Link>
                </div>
            ) : (
                <form onSubmit={submit} className="mt-6 space-y-6" data-testid="reset-form">
                    <div>
                        <label className="bc-label">Nouveau mot de passe</label>
                        <input
                            type="password"
                            required
                            minLength={8}
                            className="bc-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            data-testid="reset-password"
                        />
                    </div>
                    <div>
                        <label className="bc-label">Confirmation</label>
                        <input
                            type="password"
                            required
                            minLength={8}
                            className="bc-input"
                            value={confirm}
                            onChange={(e) => setConfirm(e.target.value)}
                            data-testid="reset-confirm"
                        />
                    </div>
                    {error && (
                        <div
                            className="border px-4 py-3 text-sm"
                            style={{ borderColor: "rgba(217,112,112,0.6)", color: "#ffb0b0", background: "#1a0a0a" }}
                            data-testid="reset-error"
                        >
                            {error}
                        </div>
                    )}
                    <button className="bc-btn w-full" disabled={loading} data-testid="reset-submit">
                        {loading ? "Enregistrement..." : "Enregistrer"}
                    </button>
                </form>
            )}
        </section>
    );
}
